"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Document;

var _react = _interopRequireDefault(require("react"));

var _colors = require("HubStyleTokens/colors");

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

function Document(props) {
  return _react.default.createElement(_UIIcon.default, Object.assign({
    color: _colors.EERIE
  }, props, {
    name: "file"
  }));
}

module.exports = exports.default;